// Re-export from the new modular structure
export {
  createCheckoutErrorHandler,
  createErrorHandler,
  createCheckoutStartConvergenceIneligibleErrorHandler,
  createCheckoutStartIdentityErrorHandler,
  createCheckoutStartRecoverableTerminalErrorHandler,
  createCheckoutStartAURegulationErrorHandler,
  createCheckoutStartProfileErrorHandler,
  createCheckoutStartComplianceErrorHandler,
  createCheckoutStartDefaultTerminalErrorHandler,
} from './checkoutErrors/index'

export type { CheckoutErrorContext, ErrorHandler } from './checkoutErrors/types'
